import {AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../../core/services/authentication/authentication.service';
import {User} from '../../../core/entities/user/user.entity';

import {UserImageComponent} from '../../../core/components/user-image/user-image.component';
import {TranslocoPipe} from '@jsverse/transloco';
import {HeaderUserMenuComponent} from '../header-user-menu/header-user-menu.component';
import {RouterLink} from '@angular/router';
import {LogoComponent} from '../../../core/components/logo/logo.component';
import {LocalStorageService} from '../../../core/services/localstorage/local-storage.service';
import {NgClass, isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-header',
  imports: [
    UserImageComponent,
    TranslocoPipe,
    HeaderUserMenuComponent,
    RouterLink,
    LogoComponent,
    NgClass
  ],
  templateUrl: './header.component.html',
  standalone: true,
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  public user: User|null = null;
  public userMenuOpened = false;
  public mobileMenuOpened = false;

  @ViewChild('userMenu') userMenuRef!: ElementRef;
  @ViewChild('userButton') userButtonRef!: ElementRef;
  @ViewChild('headerRef') headerRef!: ElementRef;

  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly localStorage: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  ngAfterViewInit() {
    this.updateHeaderHeight();
  }

  public ngOnInit() {
    this.user = this.authenticationService.getCurrentUser();
  }

  public ngOnDestroy(): void {
    this.restoreScroll();
  }

  public closeUserMenu() {
    this.userMenuOpened = false;
  }

  public toggleUserMenu() {
    this.userMenuOpened = !this.userMenuOpened;
  }

  public showPreHeader(): boolean {
    return false;
    /**
    const isPhotographer = this.user === null || !this.user.roles.includes(UserRoles.photographer);
    const hasClosedPreHeader = this.localStorage.get('closedPreHeader') === 'true';
    return isPhotographer && !hasClosedPreHeader;
      **/
  }

  public closePreHeader(): void {
    this.localStorage.save('closedPreHeader', 'true');
  }

  public toggleMobileMenu(): void {
    this.mobileMenuOpened = !this.mobileMenuOpened;
    this.toggleScroll(!this.mobileMenuOpened);
  }

  public closeMobileMenu(): void {
    if (!this.mobileMenuOpened) {
      return;
    }
    this.mobileMenuOpened = false;
    this.toggleScroll(true);
  }

  public accountUrl(): string {
    return this.user === null ? '/my-account' : '/manage';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const clickedInsideMenu =
      this.userMenuRef?.nativeElement?.contains(target) ?? false;
    const clickedInsideButton =
      this.userButtonRef?.nativeElement?.contains(target) ?? false;

    if (this.userMenuOpened && !clickedInsideMenu && !clickedInsideButton) {
      this.closeUserMenu();
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateHeaderHeight();
  }

  private toggleScroll(allowScroll: boolean): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    document.body.style.overflow = allowScroll ? '' : 'hidden';
  }

  private restoreScroll(): void {
    this.toggleScroll(true);
  }

  private updateHeaderHeight(): void {
    if (!isPlatformBrowser(this.platformId) || !this.headerRef) {
      return;
    }
    const headerHeight = this.headerRef.nativeElement.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
}
